<template>
  <footer
    class="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden"
  >
    <!-- 背景装饰 -->
    <div class="absolute inset-0 opacity-10">
      <div
        class="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"
      ></div>
      <div
        class="absolute bottom-0 right-0 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl"
      ></div>
    </div>

    <!-- 主要内容 -->
    <div class="relative container mx-auto px-4 py-12 max-w-[1800px]">
      <div class="flex flex-col md:flex-row items-center justify-between gap-6">
        <!-- 左侧：Logo 和描述 -->
        <div class="text-center md:text-left">
          <h3
            class="text-2xl font-airstrip font-bold mb-2 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent"
          >
            {{ siteInfo.name }}
          </h3>
          <p class="text-gray-400 text-sm max-w-md">{{ siteInfo.slogan }}</p>
        </div>

        <!-- 中间：快速链接 -->
        <div class="flex flex-wrap items-center justify-center gap-6">
          <template v-for="link in quickLinks" :key="link.label">
            <router-link
              v-if="!link.external"
              :to="link.path"
              class="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium"
            >
              {{ link.label }}
            </router-link>
            <a
              v-else
              :href="link.path"
              class="text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ link.label }}
            </a>
          </template>
        </div>

        <!-- 右侧：社交媒体 -->
        <div class="flex items-center gap-4">
          <a
            v-for="social in socialLinks"
            :key="social.name"
            :href="social.url"
            :aria-label="social.ariaLabel"
            class="w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-white/20 transition-all duration-300 hover:scale-110"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              class="w-5 h-5"
              :fill="social.icon === 'email' ? 'none' : 'currentColor'"
              :stroke="social.icon === 'email' ? 'currentColor' : 'none'"
              viewBox="0 0 24 24"
              v-html="getSocialIcon(social.icon)"
            ></svg>
          </a>
        </div>
      </div>

      <!-- 分隔线 -->
      <div
        class="my-8 h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent"
      ></div>

      <!-- 底部版权信息 -->
      <div
        class="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400"
      >
        <div class="flex items-center gap-2">
          <span>© {{ siteInfo.copyrightYear }}</span>
          <span
            class="font-airstrip font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent"
          >
            {{ siteInfo.name }}
          </span>
          <span>All rights reserved.</span>
        </div>

        <div class="flex items-center gap-2">
          <span>Powered by</span>
          <span class="font-bold text-white">{{ siteInfo.author }}</span>
          <span class="inline-flex items-center gap-1">
            with
            <svg
              class="w-4 h-4 text-red-500 animate-pulse"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <!-- 装饰性波浪线（可选） -->
    <div
      class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"
    ></div>
  </footer>
</template>

<script>
import {
  siteInfo,
  socialLinks,
  quickLinks,
  getSocialIcon,
} from "@/config/siteConfig";

export default {
  name: "AppFooter",
  setup() {
    return {
      siteInfo,
      socialLinks,
      quickLinks,
      getSocialIcon,
    };
  },
};
</script>

<style scoped>
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
